// extracted by mini-css-extract-plugin
module.exports = {"createFolderWindow":"createFolderWindow__bJzvC"};